import { render, staticRenderFns } from "./FjProductActionIcon.vue?vue&type=template&id=5f8d8c86&scoped=true&"
import script from "./FjProductActionIcon.vue?vue&type=script&lang=js&"
export * from "./FjProductActionIcon.vue?vue&type=script&lang=js&"
import style0 from "./FjProductActionIcon.vue?vue&type=style&index=0&id=5f8d8c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d8c86",
  null
  
)

export default component.exports